/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:f88cf872-717f-4f98-9257-dcada12fa7d2",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_9V3aOu9Bj",
    "aws_user_pools_web_client_id": "535c2tdg6d54ecqndkeblgkdao",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://6xcav4zzsba4tdcel3oxcspkta.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-6dnjxrkzvzehfkx2npxp7cuoi4",
    "aws_cloud_logic_custom": [
        {
            "name": "parsePdfApi",
            "endpoint": "https://m5d64jm8fc.execute-api.us-west-2.amazonaws.com/jives",
            "region": "us-west-2"
        },
        {
            "name": "email",
            "endpoint": "https://lu78xlibn1.execute-api.us-west-2.amazonaws.com/jives",
            "region": "us-west-2"
        },
        {
            "name": "createBestPracticePDF",
            "endpoint": "https://rvaxekr3gl.execute-api.us-west-2.amazonaws.com/jives",
            "region": "us-west-2"
        }
    ],
    "aws_user_files_s3_bucket": "edc0fcc9f1e37714ed682c9b82f069f8bbb110418-jives",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
